import React, {useState} from "react";
import {observer} from "mobx-react";
import {Col, Form, Input, Modal, Row} from "antd";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {useRequiredStore} from "../../../../../../utils/store";
import {OrderDataStoreContext} from "../../../order.data.store";
import {AxiosError} from "axios";
import {ErrorResponseData} from "../../../../../../models/core/response";

interface OrderDataHeaderModalProps {
    visible: boolean,
    onClose: () => void
}

export const OrderDataHeaderModal: React.FC<OrderDataHeaderModalProps> = observer(({visible, onClose}) => {
    const t = useTranslate();
    const store = useRequiredStore(OrderDataStoreContext);

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    return (
        <Modal
            visible={visible}
            confirmLoading={loading}
            title={t("ORDERS.ORDER.EDIT")}
            okText={t("SAVE")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            centered
            onCancel={() => {
                onClose();
                form.resetFields();
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name={"order_data"}
                initialValues={{
                    clientOrderId: store.order?.clientOrderId,
                    paymentTerms: store.order?.conditions.clientPaymentTerms || 0,
                    shipmentCondition: store.order?.conditions.clientShipmentCondition
                }}
                onFinish={() => form
                    .validateFields()
                    .then(values => {
                        setLoading(true);
                            store.editOrder(values)
                            .then(() => {
                                form.resetFields();
                                return onClose();
                            }, (e: AxiosError<ErrorResponseData>) => {
                                if (e.response?.data.fields) {
                                    form.setFields(e.response?.data?.fields);
                                }
                            })
                            .then(() =>
                                // onClose(),
                                (e: any) => form.setFields(e.response?.data?.fields))
                            .finally(() => setLoading(false));
                    })
                }
            >
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="paymentTerms"
                            label={t("PAYMENT_TERMS")}
                            rules={[{required: true, message: t('FROM.ERROR.PLEASE_ENTER_VALUE')}]}
                        >
                            <Input type="text" placeholder={t("PAYMENT_TERMS")}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="shipmentCondition"
                            label={t("SHIPMENT_CONDITION")}
                        >
                            <Input type="text" placeholder={t("SHIPMENT_CONDITION")}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="clientOrderId"
                            label={t("ORDERS.ALT_NUMBER")}
                            help={t("ORDERS.ALT_NUMBER_HELP")}
                        >
                            <Input type="text" placeholder={t("ORDERS.ALT_NUMBER")}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
});
